import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";
import CategoryIcon from "@/components/CategoryIcon";
import SaveHeart from "@/components/SaveHeart";
import TierBadge from "@/components/TierBadge";
import { CATEGORIES } from "@/data/constants";

export default function VenueCard({ venue }) {
  const cat = CATEGORIES.find(c => c.slug === venue.category);
  const graded = (venue.rating_count || 0) > 0 || venue.tier;
  return (
    <Link to={`/venue/${venue.id}`} data-testid={`venue-card-${venue.id}`} className="block group relative">
      <div className="absolute top-3 right-3 z-10">
        <SaveHeart venueId={venue.id} />
      </div>
      <Card className="bg-white rounded-xl border border-gray-200 hover:border-gray-900 transition-colors duration-200 overflow-hidden h-full">
        <CardContent className="p-6">
          <div className="flex items-start justify-between gap-3 mb-3 pr-12">
            <div className="w-10 h-10 rounded-lg bg-blue-50 text-blue-700 flex items-center justify-center border border-blue-100">
              <CategoryIcon slug={venue.category} className="w-5 h-5" />
            </div>
            {graded
              ? <TierBadge points={venue.rating} tier={venue.tier} testId={`card-tier-${venue.id}`} />
              : <span className="text-xs text-gray-500 font-medium uppercase tracking-widest">Awaiting inspection</span>}
          </div>
          <h3 className="font-heading font-semibold text-lg text-gray-900 leading-tight group-hover:text-blue-700 transition-colors duration-200">
            {venue.venue_name}
          </h3>
          <div className="mt-2 flex items-center gap-1 text-sm text-gray-600">
            <MapPin className="w-4 h-4" />
            <span>{venue.area}{venue.postcode ? ` · ${venue.postcode}` : ""}</span>
          </div>
          <p className="mt-3 text-sm text-gray-700 line-clamp-2">{venue.description}</p>
          <div className="mt-4 flex flex-wrap gap-1.5">
            <Badge variant="secondary" className="rounded-full">{cat?.short || venue.category}</Badge>
            {(venue.features || []).slice(0, 2).map(f => (
              <Badge key={f} variant="outline" className="rounded-full border-gray-300">{f}</Badge>
            ))}
            {(venue.features || []).length > 2 && (
              <Badge variant="outline" className="rounded-full border-gray-300">+{venue.features.length - 2}</Badge>
            )}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
